import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Snackbar, FontIcon } from 'react-toolbox';
import { ThemeProvider } from 'react-css-themr';
import { ToastProvider } from 'react-toast-notifications';
import NavigationBar from 'components/NavigationBar';
import Loading from 'components/Loading';
import RTSnackbar from 'styles/snackbar';
import BackToTop from '../../shared/components/BackToTop/index';

const theme = { RTSnackbar };

const Main = ({
  children, isAuthenticating, error, location,
}) => (<ToastProvider autoDismiss autoDismissTimeout={2000}>
  <div>
    <NavigationBar location={location} />
    {error && error.messages && <ThemeProvider theme={theme}>
      <Snackbar active type="warning">
        <FontIcon value="warning" />
        {error.messages.join(', ')}
      </Snackbar>
    </ThemeProvider>}
    {isAuthenticating ? <Loading /> : children}
    <BackToTop />
  </div>
</ToastProvider>);

Main.propTypes = {
  children: PropTypes.node,
  isAuthenticating: PropTypes.bool,
  role: PropTypes.string,
  error: PropTypes.shape({ messages: PropTypes.arrayOf(PropTypes.string) }),
  location: PropTypes.object,
};

export default connect(state => ({
  isAuthenticating: state.user.isAuthenticating,
  role: state.user.role,
  error: state.error,
}))(Main);



// WEBPACK FOOTER //
// ./client/app/screens/main/index.jsx